module.exports = __webpack_public_path__ + "./docs/img/big-icon-const.aad919052e4e954170c829a9de7e06d3.svg";